import React from "react";
import { Bar } from "react-chartjs-2";
import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

const separatorPlugin = {
  id: "separatorLine",
  afterDraw(chart, _args, pluginOptions) {
    const separatorIndex = pluginOptions?.separatorIndex;
    if (separatorIndex == null) return;
    const { ctx, chartArea, scales } = chart;
    const xScale = scales.x;
    const step = xScale.getPixelForValue(1) - xScale.getPixelForValue(0);
    const xPos = xScale.getPixelForValue(separatorIndex) - step / 2;
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(xPos, chartArea.top);
    ctx.lineTo(xPos, chartArea.bottom);
    ctx.strokeStyle = "#bbb";
    ctx.lineWidth = 1.5;
    ctx.setLineDash([5, 4]);
    ctx.stroke();
    ctx.restore();
  },
};

const VisitsChart = ({
  labels = [],
  visitasData = [],
  pesquisasData = [],
  pesquisasSemErroData = [],
  separatorIndex = null,
}) => {
  const chartData = {
    labels,
    datasets: [
      {
        label: "Total de Visitas Válidas",
        data: visitasData,
        backgroundColor: "#1A2B49",
        barPercentage: 0.85,
        categoryPercentage: 0.75,
      },
      {
        label: "Total de Pesquisas",
        data: pesquisasData,
        backgroundColor: "#4472C4",
        barPercentage: 0.85,
        categoryPercentage: 0.75,
      },
      {
        label: "Total de Pesquisas sem Erro",
        data: pesquisasSemErroData,
        backgroundColor: "#70AD47",
        barPercentage: 0.85,
        categoryPercentage: 0.75,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: { padding: { top: 24 } },
    plugins: {
      legend: {
        position: "bottom",
        align: "start",
        labels: {
          font: { size: 12 },
          padding: 20,
          usePointStyle: true,
          pointStyle: "rectRounded",
          pointStyleWidth: 16,
          boxHeight: 10,
        },
      },
      separatorLine: {
        separatorIndex,
      },
      tooltip: {
        callbacks: {
          label: (ctx) => ` ${ctx.dataset.label}: ${ctx.raw}`,
        },
      },
      datalabels: {
        color: "#1A2B49",
        font: { size: 10, weight: "bold" },
        formatter: (value) => (value > 0 ? value : ""),
        anchor: "end",
        align: "top",
        offset: 2,
        clamp: true,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { font: { size: 11, weight: "600" }, color: "#1A2B49" },
      },
      y: {
        beginAtZero: true,
        grid: { color: "#f0f0f0" },
        ticks: { display: false },
      },
    },
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-lg font-bold text-gray-800 mb-4">Visitas</h2>
      <div style={{ height: 320 }}>
        <Bar data={chartData} options={options} plugins={[separatorPlugin]} />
      </div>
    </div>
  );
};

export default VisitsChart;
